import React from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../../lib/http/axiosConfig";
import { useT } from "../../i18n";

const LogoutButton = ({ className = "" }) => {
  const navigate = useNavigate();
  const t = useT();

  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      navigate("/login");
    }
  };

  return (
    <button
      onClick={handleLogout}
      className={`logout-button ${className}`}
      style={{
        background: "none",
        border: "none",
        color: "#667eea",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "500",
        padding: "8px 16px",
        borderRadius: "6px",
        transition: "background-color 0.3s ease",
      }}
      onMouseOver={(e) => {
        e.target.style.backgroundColor = "#f0f2ff";
      }}
      onMouseOut={(e) => {
        e.target.style.backgroundColor = "transparent";
      }}
    >
      {t("common.logout.label")}
    </button>
  );
};

export default LogoutButton;
